<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Comissões</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <d-col sm="6" class="d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span
                v-if="countFilter > 0"
                class="badge badge-light"
              >{{countFilter}}</span>
            </button>
            <b-button
              v-if="countFilter > 0"
              variant="primary"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </b-button>
          </div>
        </d-col>
      </div>
      <!-- Default Light Table -->
      <d-row v-show="this.ListCommissions.Amount > 0">
        <!-- Cards -->
        <d-col v-for="(card, index) in Cards" :key="index" md="10" lg="4" class="mb-4">
          <cards :id="`card-${index}`" :label="card.label" :value="card.value" :small="true" />
        </d-col>
      </d-row>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Comissões a receber</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6
                    class="m-0"
                  >{{pagination.TotalItems | number}} {{pagination.TotalItems > 1 ? " itens" : "item"}}</h6>
                  <div class="dropdown m-0" id="meu-querido-dropdown">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : '' "
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader :small="true" :isLoading="loadingReport"></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReportVendor ? 'disabled' : '' "
                        v-on:click.stop="GetReportVendor($event)"
                      >
                        <template v-if="loadingReportVendor">
                          <loader :small="true" :isLoading="loadingReportVendor"></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório por vendedor
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Cliente</th>
                    <th scope="col" class="border-0">Método de Pagamento</th>
                    <th scope="col" class="border-0">Data de Pagamento</th>
                    <th scope="col" class="border-0">Vendedor</th>
                    <th scope="col" class="border-0">Valor</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(commission, index) in ListCommissions.Objects" :key="index">
                    <td></td>
                    <td class="text-left td-with-subs">
                      <div>{{commission.Merchant.CommercialName | substring(50)}}</div>
                      <span>{{commission.Merchant.Identity | identity }}</span>
                    </td>
                    <td>{{commission.PaymentMethod.Name}}</td>
                    <td>{{commission.PaymentDate | date}}</td>
                    <td>{{commission.NameVendor}}</td>
                    <td>
                      <span class="badge badge-success">{{commission.Amount | currency}}</span>
                    </td>
                    <td></td>
                  </tr>
                  <tr
                    v-show="ListCommissions.Objects.length == 0 || ListCommissions.Objects == undefined"
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <date-field v-model="filter.InitialDate" format="MMMM yyyy" minimumView="month"></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodePaymentMethod" :value="null">
            <option :value="null" selected>Método de pagamento</option>
            <option
              v-for="type in paymentMethods"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >{{type.Name}}</option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            v-bind:placeholder="labelIdentity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="12" class="form-group">
          <d-select v-model="filter.IdUserPartner" :value="null">
            <option :value="null" selected>Vendedor</option>
            <option :value="0" selected>Sem vendedor</option>
            <option v-for="user in users" v-bind:key="user.Id" v-bind:value="user.Id">{{user.Name}}</option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "@/components/common/date-field";
import cards from "@/components/common/cards";
export default {
  name: "commissions",
  data: function() {
    return {
      loadingList: false,
      loadingReport: false,
      loadingReportVendor: false,
      countFilter: 1,
      labelName: "Cliente",
      labelIdentity: "CPF/CNPJ",
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
        TotalCommission: 0,
        IsReceived: false
      },
      filter: {
        Name: null,
        Identity: null,
        CodePaymentMethod: null,
        IdUserPartner: null,
        InitialDate: this.$options.filters.date(new Date(), "YYYY-MM-DD")
      },
      paymentMethods: [],
      users: [],
      ListCommissions: { Message: "", ReleaseDate: "", Objects: [] }
    };
  },
  components: {
    dateField,
    cards
  },
  computed: {
    Prospects() {
      return this.$store.getters.Prospects;
    },
    Cards() {
      return [
        {
          label: "Valor a receber",
          value: this.$options.filters.currency(this.ListCommissions.Amount)
        },
        {
          label: "Status",
          value: this.ListCommissions.Message
        },
        {
          label: "Data de recebimento",
          value: this.$options.filters.date(this.ListCommissions.ReleaseDate)
        }
      ];
    }
  },
  watch: {
    "pagination.PageNumber": function() {
      this.ListCommission();
    },
    "pagination.RowsPerPage": function() {
      this.ListCommission();
    }
  },
  mounted() {
    this.ListPaymentMethod();
    this.ListUserPartner();
    this.ListCommission();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListCommission();
    },
    ListPaymentMethod: function() {
      this.$store
        .dispatch("ListPaymentMethod")
        .then(response => {
          this.paymentMethods = response;
        })
        .catch(error => {
          this.$makeToast(
            "Não foi possível listar os métodos de pagamento",
            "danger",
            "Recebimento de Comissões",
            error
          );
        });
    },
    ListUserPartner: function() {
      let data = {
        ...{
          "Object.UserProfilePartner.Code": 2,
          "PageNumber": 0,
          "RowsPerPage": 0,
        },
      };
      this.$store
        .dispatch("ListUser", { params: data })
        .then(response => {
          this.users = response.Objects;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter lista de usuários",
            error
          );
        });
    },
    GetParamsData: function(deletePagination = false) {
      let data = {
        ...this.pagination,
        ...{
          "Object.Merchant.Name": this.filter.Name,
          "Object.Merchant.Identity": this.filter.Identity,
          "Object.PaymentMethod.Code": this.filter.CodePaymentMethod,
          "UserPartner.Id": this.filter.IdUserPartner,
          InitialDate: this.filter.InitialDate
        }
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.RowsPerPage;
        delete data.PageNumber;
      }
      return data;
    },
    ListCommission: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.CodePaymentMethod)) this.countFilter++;
      if (hasValue(this.filter.InitialDate)) this.countFilter++;
      if (hasValue(this.filter.IdUserPartner)) this.countFilter++;
      this.loadingList = true;
      let data = this.GetParamsData();
      this.$store
        .dispatch("ListCommissions", { params: data })
        .then(
          response => {
            this.ListCommissions = response;
            this.pagination.TotalCommission = response.TotalCommission;
            this.pagination.TotalItems = response.TotalItems;
            this.pagination.IsReceived = response.IsReceived;
          },
          error => {
            this.$makeToast(
              "Não foi possível listar suas Comissões",
              "danger",
              "Recebimento de Comissões",
              error
            );
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },
    ResetFilter: function() {
      this.filter = {
        Name: null,
        Identity: null,
        CodePaymentMethod: null,
        IdUserPartner: null,
        InitialDate: this.filter.InitialDate
      };
      this.ListCommission();
    },
    GetReport: function(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportCommission", { params: data })
        .then(response => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(
            "Falha ao gerar relatório, tente novamente",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          setTimeout(() => {
            $("#meu-querido-dropdown > .dropdown-menu").removeClass("show");
            this.loadingReport = false;
          }, 250);
        });
    },
    GetReportVendor: function(ev) {
      ev.preventDefault();
      this.loadingReportVendor = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportCommissionVendor", { params: data })
        .then(response => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(
            "Falha ao gerar relatório, tente novamente",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          setTimeout(() => {
            $("#meu-querido-dropdown > .dropdown-menu").removeClass("show");
            this.loadingReportVendor = false;
          }, 250);
        });
    }
  }
};
</script>

<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/commissions.vue